export default __webpack_public_path__ + "static/media/dinner.503d13e4.svg";